<template>
  <RegionsComponent />
</template>

<script>
// @ is an alias to /src
import RegionsComponent from "@/sections/voiceplus/components/RegionsComponent.vue";
import config from "@/config";

export default {
  name: "Regions",
  components: {
    RegionsComponent,
  },
  data: function () {
    return {
      sections: config.Sites,
    };
  },
};
</script>
